import { render, staticRenderFns } from "./WebsiteHeader.vue?vue&type=template&id=6a0a2c80&scoped=true&"
import script from "./WebsiteHeader.vue?vue&type=script&lang=js&"
export * from "./WebsiteHeader.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteHeader.vue?vue&type=style&index=0&id=6a0a2c80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0a2c80",
  null
  
)

export default component.exports